export enum ValuationControlModalModes {
  VIEW = "view",
  EDIT = "edit",
}
